export default __webpack_public_path__ + "static/media/profile.07b85e1f.png";